import type { DataSourceEntry } from "../../types/DataSourceEntry";
import type { DataSourceEntryDto } from "../../services/ApiService";
import DataSourceEntryId from "../../state/DataSourceEntryId";

export const toDataSourceEntry = (dto: DataSourceEntryDto): DataSourceEntry => ({
  id: DataSourceEntryId.from(dto.id),
  data: dto.data,
});
